module.exports = __webpack_public_path__ + "static/PostgresQL_Balloon-11673b029e56af72d0a54c9c17285bda.png";